import { Link } from 'react-router-dom';
import Colors from '@/constants/colors';

interface SectionHeaderProps {
  title: string;
  seeAllLink?: string;
  seeAllText?: string;
}

export default function SectionHeader({ title, seeAllLink, seeAllText }: SectionHeaderProps) {
  return (
    <div style={styles.container}>
      <h2 style={styles.title}>{title}</h2>
      {seeAllLink && seeAllText && (
        <Link to={seeAllLink} style={styles.link}>
          {seeAllText}
        </Link>
      )}
    </div>
  );
}

const styles = {
  container: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '16px',
    padding: '0 24px',
  } as React.CSSProperties,

  title: {
    fontSize: '22px',
    fontWeight: '700',
    color: Colors.text,
    margin: 0,
  } as React.CSSProperties,

  link: {
    fontSize: '14px',
    fontWeight: '600',
    color: Colors.primary,
    textDecoration: 'none',
    cursor: 'pointer',
  } as React.CSSProperties,
};
